import styled from 'styled-components';
import { Box } from '@mui/material';

export const BOHServiceDistributionStyle = styled.div`
.serviceDistributionInput{
    font-size:14px;
    .MuiInputBase-input{
        height: 0.2375em;
        /*background-color: #E4E4E4;*/
        border-radius: 5px;
        font-weight: 600;
        font-size:14px;
    }
    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
        opacity: 1;
        -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
    }
    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{
        height:30px;
    }
}

  
`;